import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;

export function createReportApi(prefix, options = {}) {
    const base = adminApi + prefix;
    // drive 域的核心场景路径与 v1/v2 不同，通过 options 覆盖
    const coreSceneTreePath  = options.coreSceneTreePath  || 'car/coreScene/tree';
    const coreSceneVideoPath = options.coreSceneVideoPath || 'car/coreScene/videos';
    return {
        getReportIndexData:    (p={}) => http.fetchGet(base + 'index', p),
        getRecommendCar:       (p={}) => http.fetchGet(base + 'recommend', p),
        getRankData:           (p={}) => http.fetchGet(base + 'rank', p),
        getRankNodeData:       (p={}) => http.fetchGet(base + 'rankNode', p),
        getCarSummaryData:     (p={}) => http.fetchGet(base + 'car/detail', p),
        getCarScore:           (p={}) => http.fetchPost(base + 'car/node', p),
        getCarScoreInnovate:   (p={}) => http.fetchPost(base + 'car/innovateNode', p),
        getTestDetail:         (p={}) => http.fetchPost(base + 'car/nodeDetail', p),
        getInnovateDetail:     (p={}) => http.fetchPost(base + 'car/innovateNodeDetail', p),
        getInnovateLineDetail: (p={}) => http.fetchPost(base + 'car/innovateAnalysisData', p),
        getNodeLineDetail:     (p={}) => http.fetchPost(base + 'car/functionAnalysisData', p),
        getNodeLineTwoDetail:  (p={}) => http.fetchPost(base + 'car/functionAnalysisDetail', p),
        addCompareCar:         (p={}) => http.fetchPost(base + 'user/addCompareCar', p),
        delCompareCar:         (p={}) => http.fetchPost(base + 'user/delCompareCar', p),
        getCompareCarList:     (p={}) => http.fetchPost(base + 'user/compareCarList', p),
        changeUserCar:         (p={}) => http.fetchPost(base + 'user/updatePersonalizationCar', p),
        searchNode:            (p={}) => http.fetchPost(base + 'search/node', p),
        getParentNodes:        (p={}) => http.fetchPost(base + coreSceneTreePath, p),
        getNodeVideos:         (p={}) => http.fetchPost(base + coreSceneVideoPath, p),
        addCollect:            (p={}) => http.fetchPost(base + 'user/addCollect', p),
        delCollect:            (p={}) => http.fetchPost(base + 'user/delCollect', p),
        getSearchModel:        (p={}) => http.fetchPost(base + 'car/permissionInfo', p),
        getSearchResoult:      (p={}) => http.fetchPost(base + 'search/nodeCompare', p),
        getSearchCar:          (p={}) => http.fetchPost(base + 'search/car', p),
        getSearchResoultCx:    (p={}) => http.fetchPost(base + 'search/innovateNodeCompare', p),
    };
}
